import React from "react";
import { useState } from "react";
import { addParamUrl } from "../../../../utils";
import { GroupSpecialGochiKidDetailModal } from "./GroupSpecialGochiKidDetailModal";
import GochiService from "../../../../api/services/GochiService";
import moment from "moment";
import { GochiKidGroupNoteModal } from "./GochiKidGroupNoteModal";
import { GOCHI_KID_GROUP_NAME_HAS_NOTE } from "../../../../constants";

export function SumugochiErrorModal(props) {
  return (
    <>
      <div
        className={
          props.showing
            ? "custom-modal-container group-special-gochi-kid-modal sumugochi-error-modal show-modal"
            : "custom-modal-container group-special-gochi-kid-modal sumugochi-error-modal"
        }
        size="sm"
      >
        <div
          className={
            props.showing
              ? "modal modal-action modal-dialog is-show history-modal max-width-335"
              : "modal modal-action modal-dialog history-modal max-width-335"
          }
        >
          <div className="modal-header-history">
            <button
              className="modal-btn modal-btn-close"
              id="modalClose"
              onClick={() => props.handleClose()}
              type="button"
            >
              <svg className="icon">
                <title>閉じる</title>
                <use xlinkHref="/assets/img/common/icon.svg#times" />
              </svg>
            </button>
          </div>
          <div className="title-modal title-modal-charge">
            <div className="title">支援元を選ぶ</div>
          </div>
          <div className={`modal-body`}>
            <div className="font-weight-700">
              「
              {props.listGroupSpecialGochiKidAll[0]?.gochiKidGroupName ??
                "Sumuごち"}
              」のご利用にあたり、「こどもごちめし利用者情報登録」をお願いいたします。
              <br />
              ー
              <br />
              ・支援対象のお子様の情報登録が必須となります。
              <br />
              ・登録及び審査完了後、ご利用いただけます。
              <br />
              ー
              <br />
              本サービス「
              {props.listGroupSpecialGochiKidAll[0]?.gochiKidGroupName ??
                "Sumuごち"}
              」は、対象エリア在住の方のみご利用いただけます。詳しくは
              <a href="https://sumu-hotel.com/news/mao52swpc/" target="_blank">
                こちら
              </a>
              をご覧ください。
              <br />ー
              <div style={{ textAlign: "center" }}>
                ▼
                <br />
                <a href="/mypage/kodomo_use">
                  こどもごちめし利用者情報登録はこちら
                </a>
                <br />
                <br />
                <a
                  href="https://drive.google.com/file/d/18DQ6Krdn1eoXow6h2KNnzEO88a_yc_6G/view"
                  target="_blank"
                >
                  こどもごちめし利用者情報登録マニュアルはこちら
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="back-drop" />
      </div>
    </>
  );
}
